import { TFunction } from 'i18next';

import { isOverCharacterLimit, shouldWarnForUnsafeCharacters } from '../utils';

export const MAX_NAME_LENGTH = 40;

/**
 * Validates a visitor name.
 *
 * @param name - The name to validate.
 * @param isRequired - Whether or not name is required (determines if we should
 * error on empty name).
 * @returns true if the name is valid, or an error message if the name is invalid.
 */
export function validateVisitorName(t: TFunction, name: string, isRequired = true): true | string {
  if (isRequired && name.trim().length === 0) {
    return t('telehealth-core:formErrorsCore.thisFieldIsRequiredPleaseEnter');
  }
  if (isOverCharacterLimit(name, MAX_NAME_LENGTH)) {
    return t('telehealth-core:formErrorsCore.thisEntryIsTooLong');
  }
  if (shouldWarnForUnsafeCharacters(name)) {
    return t('telehealth-core:formErrorsCore.thisEntryContainsUnacceptedCharacters');
  }
  return true;
}
